module.exports = __webpack_public_path__ + "static/img/4en.1655d0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/rongyao/4en.png
// module id = plTu
// module chunks = 0